export const GET_DELIVERY_DATA_LIST_REQUEST = 'GET_DELIVERY_DATA_LIST_REQUEST'
export const GET_DELIVERY_DATA_LIST_SUCCESS = 'GET_DELIVERY_DATA_LIST_SUCCESS'
export const GET_DELIVERY_DATA_LIST_FAILED = 'GET_DELIVERY_DATA_LIST_FAILED'
export const CLEAR_DELIVERY_DATA = 'CLEAR_DELIVERY_DATA'
export const GET_DELIVERY_DATA_LIST_NULL = 'GET_DELIVERY_DATA_LIST_NULL'
